import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {FormattedDate, FormattedTime} from 'react-intl';
import ModalConfirm from '../ModalConfirm'
import {copiaTestoNegliAppunti, getShortText} from "../../Helpers";
import {client} from '../../Client';
import LocalDate from "../LocalDate";
import LocalTime from "../LocalTime";

class NewsTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.news;

        let editBtn = null;
        if (this.props.readOnly === false){
            editBtn =(
                <Link  className="ui blue icon button" to={`/app/news/edit/${c.idNews}`}>
                    <i
                        className="edit icon"

                    ></i>
                </Link>
            );
        }

        let inCommessaLink = null;
        if(c.idCommessa){
            if (client.getCurrentUser().isrolecommessew) {
                inCommessaLink = (<label className="ui gray rounded label"><Link to={`/app/commesse/view/${c.idCommessa.idCommessa}`}>{c.idCommessa.nomeCompleto}</Link></label>);
            }else{
                inCommessaLink= (<label className="ui gray label">{c.idCommessa.nomeCompleto}</label>)
            }
        }
        let inGaraLink = null;
        if(c.idGara){
            if (client.getCurrentUser().isrolegarew) {
                inGaraLink = (<label className="ui gray rounded label"><Link to={`/app/gare/view/${c.idGara.idGara}`}>{c.idGara.nomeCompleto}</Link></label>);
            }else{
                inGaraLink= (<label className="ui gray label">{c.idGara.nomeCompleto}</label>)
            }
        }
        let statoNewsUtente = "";
        if (!c.archiviata){
            statoNewsUtente = c.newsViewsList.reduce(
                (pv, cv)=>{
                    if (cv.idUtente.idUtente===client.getCurrentUserId()) {
                        if (cv.visibile === 1){
                            return "Da leggere";
                        } else if (cv.visibile === 2){
                            return "Letta";
                        } else if (cv.visibile === 3){
                            return "Scartata";
                        } else{
                            return pv;
                        } 
                    }
                    return pv;
                }, "Archiviata"
            );
        }
        

        let visibilitaCambiataUtente = c.newsViewsList.reduce((pv, cv)=>cv.visibile !== 1 && cv.idUtente.idUtente===client.getCurrentUserId() ? true : false || pv, false);

        let ResetVisibilityUserButton = null;
        if (this.props.readOnly === false && visibilitaCambiataUtente === true) {
            ResetVisibilityUserButton = (<ModalConfirm
                msg={"Stai per ripristinare lo stato a 'Da leggere' della notizia: " + c.titolo + "."}
                msgDescription={(<h3>La notizia indicata, pubblicata in data  <span><LocalDate data={c.creatoIl } /> </span>, sarà di nuovo nello stato 'Da leggere' solo per te.</h3>)}
                onClickOk={(ev) => (this.props.onResetVisibilityUser(ev, c))}
            >
                <a className="ui yellow icon button" data-tooltip="Rimetti 'Da leggere' per te."><i className="eye icon"/></a>
            </ModalConfirm>);
        }

        let visibilitaCambiata = c.newsViewsList.reduce((pv, cv)=>cv.visibile !== 1 ? true : false || pv, false);
        // let msgTip = null;
        // if (visibilitaCambiata){
        //     msgTip = "Alcuni utenti hanno impostato un nuovo stato a questa news";
        // }
        let ResetVisibilityButton = null;
        if (this.props.readOnly === false && client.getCurrentUser().isadmin && visibilitaCambiata) {
            ResetVisibilityButton = (<ModalConfirm
                msg={"Stai per ripristinare lo stato a 'Da leggere' per tutti gli utenti della notizia: " + c.titolo + "."}
                msgDescription={(<h3>La notizia indicata, pubblicata in data  <span><LocalDate data={c.creatoIl } /> </span>, sarà di nuovo nello stato 'Da leggere' per tutti.</h3>)}
                onClickOk={(ev) => (this.props.onResetVisibility(ev, c))}
            >
                <a className="ui orange icon button" data-tooltip="Rimetti 'Da leggere' per tutti gli utenti."><i className="eye icon"/></a>
            </ModalConfirm>);
        }

        let deleteButton = null;
        if (this.props.readOnly === false && client.getCurrentUser().isadmin) {
            deleteButton = (<ModalConfirm
                msg={"Stai per cancellare la notizia: " + c.titolo + "."}
                msgDescription={(<h3>Verrà <span>cancellata</span> la notizia indicata, pubblicata in data  <span><LocalDate data={c.creatoIl } /> </span>.</h3>)}
                onClickOk={(ev) => (this.props.onDeleteItem(ev, c))}
            >
                <a className="ui red icon button"><i className="trash icon"/></a>
            </ModalConfirm>);
        }
        let lnkTitolo = (<strong>{c.titolo}</strong>);
        if (this.props.readOnly === false){
            lnkTitolo = <Link to={`/app/news/edit/${c.idNews}`}><strong>{c.titolo}</strong></Link>;
        }

        return (
            <tr>
                <td className="collapsing">{c.idNews}</td>
                <td className="collapsing center aligned">
                    <FormattedDate
                        value={c.dataPubblicazione}
                        day="numeric"
                        month="numeric"
                        year="numeric"
                    />
                </td>
                <td className="collapsing center aligned">
                    <FormattedDate
                        value={c.dataAggiornamento}
                        day="numeric"
                        month="numeric"
                        year="numeric"
                    /> - 
                    <FormattedTime
                        value={c.dataAggiornamento}
                        hour="numeric"
                        minute="numeric"
                    />
                </td>
                <td className="sorted descending">{lnkTitolo}

                    <div className="sub header">
                            <div className="content">
                                {getShortText(c.testo, 300)}
                            </div>
                            <div className="content">
                                {inCommessaLink} {inGaraLink}
                            </div>
                        <div className="content">
                            Creata il {c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>} da <b>{c.creatoDa ? c.creatoDa.username : '?'}</b>&nbsp;
                            Modificata il {c.modificatoIl ?  <b><LocalDate data={c.modificatoIl } /> <LocalTime data={c.modificatoIl } /></b> : <b>?</b>} da <b>{c.modificatoDa ? c.modificatoDa.username : '?'}</b>
                        </div>
                    </div>
                </td>
                <td className="collapsing center aligned">
                    {c.idGara && c.idGara.presentazione ? 
                        c.idGara.presentazione
                    : null}                    
                </td>
                <td className="collapsing center aligned">
                    {c.idGara && c.idGara.sopralluogo ? 
                        c.idGara.sopralluogo
                    : null}                    
                </td>
                <td className="collapsing center aligned">
                    {c.idGara && c.idGara.chiarimenti ? 
                        c.idGara.chiarimenti
                    : null}                    
                </td>
                <td className=" center aligned">
                    <div className="sub header">
                            <div className="content">
                                {statoNewsUtente}
                            </div>
                    </div>
                    
                    {c.archiviata ? <label className="ui red rounded label">Archiviata</label> : <div></div> }
                    <span></span> 
                    {ResetVisibilityButton}
                    <span></span> 
                    {ResetVisibilityUserButton}
                    
                </td>
                <td className="collapsing no-print">
                   
                    {editBtn}
                    {deleteButton}
                </td>
            </tr>)
    }
}

export default NewsTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsTableRow.js
 **/